import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../theme/theme";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import AdvisorSideBar from "../components/AdvisorSideBar/AdvisorSideBar";
import {
  LineChart,
  Line,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  YAxis,
  Legend,
} from "recharts";
import AdvisorIndividualClientSummaryModal from "../components/AdvisorIndividualClientSummaryModal/AdvisorIndividualClientSummaryModal";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { useEffect, useState } from "react";
import { SET_LOADING } from "../redux/action-types";
import {
  getAssetUnderManagementGraph,
  getDashboardTopClients,
  advisorClientDetailsAction,
  getIndividualAccountNotes,
  resetAdvisorNote,
  postAdvisorNote,
  individualAccountDetailsAction,
  getDashboardRelationships,
} from "./../redux/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import ReactApexChart from "react-apexcharts";

const BodyWrapper = styled.div`
  padding-left: 100px;
  padding-right: 20px;
  background-color: white;

  .topSection {
    padding-top: 50px;
    padding-bottom: 100px;

    .greetingsSection {
      width: 50%;
      font-size: 40px;

      .welcomeMessage {
        color: ${theme.colors.primaryStrong2X};
      }

      .userName {
        color: ${theme.colors.primaryStrong};
      }
    }

    .chartsAndTables {
      .section {
        .sectionHeading {
          font-weight: 700;
          font-size: 25px;
          color: #004576;
          margin-bottom: 20px;
          margin-top: 40px;
        }

        .heading {
          color: #0d2333;
          margin-bottom: 20px;
          margin-top: 40px;
          font-size: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .filterButton {
            border: none;
            background-color: white;
            border-radius: 10px;
            padding: 5px 20px;
            font-size: 12px;
            margin-left: 10px;
            box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
            cursor: pointer;
          }
        }

        .benchmarkChart {
          display: flex;
          align-items: center;
          background-color: white;
          width: 96.5%;
          border-radius: 8px;
          padding: 30px 20px;
          box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);

          .info {
            width: 25%;
            text-align: center;
            .total {
              color: #004576;
              font-size: 50px;
              font-weight: 700;
              margin-bottom: 10px;
            }
            .categoryData {
              display: flex;
              gap: 20px;
              justify-content: center;
              margin-top: 20px;

              .eachCategoryData {
                .categoryTotal {
                  color: #004576;
                  font-size: 25px;
                  font-weight: 700;
                }

                .categoryName {
                  margin-top: 6px;
                  color: #004576;
                  font-weight: 12px;
                  font-size: 18px;
                }
              }
            }
          }
          .chart {
            width: 75%;

            .recharts-legend-item {
              border: 1px solid lightgray;
              padding: 0px 10px;
              border-radius: 10px;
              padding-bottom: 2px;
              cursor: pointer;
            }

            .inactive {
              display: flex;
              align-items: center;
              border-radius: 15px;
              background-color: #eeeeee;
              padding: 0px 10px;
              cursor: pointer;
              padding-bottom: 1.5px;
            }

            .custom-tooltip {
              border-radius: 8px;
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 0px 10px #00000029;
              padding: 5px 10px;
              font-size: 10px;

              .date {
                text-align: center;
              }

              .labelPortfolio {
                display: flex;
                gap: 10px;
                .circle {
                  height: 22px;
                  width: 22px;
                  border-radius: 50%;
                  background-color: #33ccff;
                }
                .value {
                  font-size: 17px;
                  font-weight: 700;
                }
              }

              .label {
              }
            }
          }
        }
      }
    }

    .relationshipTopAccounts {
      display: flex;
      gap: 20px;
      width: 97%;

      .relationship {
        width: 50%;
        .sectionHeading {
          font-weight: 700;
          color: #004576;
          font-size: 25px;
          margin-bottom: 20px;
          margin-top: 40px;
        }

        .relationshipCard {
          background-color: white;
          border-radius: 8px;
          padding: 40px 40px;
          margin-bottom: 20px;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;

          .flexContainer {
            display: flex;
            align-items: center;
            height: 100%;

            .chartContainer {
              width: 85%;
              position: relative;
              display: flex;
              padding-right: 50px;

              .apexcharts-datalabel-value {
                font-weight: 700;
                font-size: 30px;
                fill: #004576;
              }

              .totalValue {
                position: absolute;
                top: 50px;
                color: #004576;
                font-weight: 700;
                font-size: 20px;
                @media only screen and (min-device-width: 1400px) and (max-device-width: 1700px) {
                  left: 42%;
                }
                @media only screen and (min-device-width: 1701px) and (max-device-width: 2400px) {
                  left: 38%;
                }
                @media only screen and (min-device-width: 2401px) and (max-device-width: 2939px) {
                  left: 42%;
                }
                @media only screen and (min-device-width: 2940px) and (max-device-width: 3000px) {
                  left: 48%;
                }
              }
            }

            .arrowContainer {
              text-align: right;
              width: 15%;
              font-size: 30px;
              color: #004576;
            }

            .openInvitationsContainer {
              width: 100%;
            }

            .informationContainer {
              width: 100%;
              gap: 50px;
              align-items: center;
              position: relative;

              .legends {
                display: flex;
                align-items: center;
                height: 100%;
                .customLegend {
                  width: 100%;
                  text-align: center;
                  gap: 20px;
                  align-items: center;
                  .identifier {
                    width: 20px;
                    height: 15px;
                    border-radius: 3px;
                  }

                  .name {
                    width: 100%;
                    color: #004576;
                  }

                  .value {
                    width: 100%;
                    font-weight: 700;
                    font-size: 40px;
                  }
                }
              }
            }
          }
        }
      }
      .topAccounts {
        width: 50%;
        .sectionHeading {
          font-weight: 700;
          color: #004576;
          font-size: 25px;
          margin-bottom: 20px;
          margin-top: 40px;
        }

        .topAccountsCard {
          background-color: white;
          width: 95%;
          border-radius: 8px;
          padding: 40px 40px;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;

          .progressBar {
            margin-top: 20px;
            width: 100%;
            display: flex;
            height: 30px;
            border-radius: 10px;
          }

          .filter {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 20px;

            .filterButton {
              font-size: 18px;
              cursor: pointer;
              padding: 10px 15px;
              color: #004576;
              background-color: white;
              border-radius: 5px;
              border: 1px solid white;
            }
            .active {
              border: 1px solid #004576 !important;
            }
          }

          .data {
            width: 100%;
            margin-top: 40px;
            table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0 12px;
              font-size: 18px;
              tr {
                margin-top: 5px;
              }

              th {
                color: #004576;
              }
              th:not(:first-child) {
                text-align: right;
              }
              th:first-child {
                text-align: left;
              }

              td:not(:first-child) {
                text-align: right;
              }
              td:first-child {
                text-align: left;
                color: #004576;
                display: flex;
                align-items: center;
                gap: 10px;
                .box {
                  width: 15px;
                  border-radius: 5px;
                  height: 15px;
                }
              }
            }
          }
        }
      }
    }

    .linkSection {
      width: 50%;
      display: flex;
      justify-content: end;
    }
  }
`;

const AdvisorPortalLanding = () => {
  const {
    userAccountDetails,
    getAssetUnderManagement,
    loading,
    topClients,
    advisorClientDetails,
    individualAccountNotes,
    individualAccountDetails,
    setAdvisorNote,
    advisorDashboardRelationships,
  } = useSelector((state) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const [isAllclientsVisible, setIsAllclientsVisible] = useState(false);
  const [isManagedVisible, setIsManagedVisible] = useState(false);
  const [isRetailVisible, setisRetailVisible] = useState(false);
  const [assetUnderManagementData, setAssetUnderManagementData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [currentTopClients, setCurrentTopClients] = useState([]);
  const [selecetdFilteButtonInTopClients, setSelecetdFilteButtonInTopClients] =
    useState("All");
  const [activeAccountId, setActiveAccountId] = useState("");
  const [
    isAdvisorIndividualClientSummaryModalShow,
    setIsAdvisorIndividualClientSummaryModalShow,
  ] = useState(false);

  const chartData = {
    options: {
      chart: { type: "donut" },
      legend: { show: false },
      dataLabels: { enabled: false },
      tooltip: { enabled: false },
      fill: { colors: ["#004576", "#008EF2"] },
      states: {
        hover: { filter: { type: "none" } },
        active: { filter: { type: "none", value: 1 } },
      },
      stroke: { width: 0 },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "75%",
            labels: {
              show: true,
              name: { show: false },
              total: {
                show: true,
                showAlways: true,
              },
            },
          },
        },
      },
    },
  };

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(getAssetUnderManagementGraph());
    dispatch(getDashboardTopClients());
    dispatch(getDashboardRelationships());
  }, []);

  useEffect(() => {
    setCurrentTopClients(topClients?.topClients);
  }, [topClients]);

  useEffect(() => {
    if (getAssetUnderManagement) {
      dispatch({ type: SET_LOADING, payload: false });
      setIsLoaded(true);
    }
    let tempData = [];
    let isRetail0 = true;
    getAssetUnderManagement?.graphValues?.forEach((data) => {
      tempData.push({
        date: new Date(data?.date).toLocaleDateString(),
        aum: parseFloat(data?.aum).toFixed(2),
        managedClientsAUM: parseFloat(data?.managedClientsAUM).toFixed(2),
        retailClientsAUM: parseFloat(data?.retailClientsAUM).toFixed(2),
      });

      if (data?.retailClientsAUM > 0) isRetail0 = false;
    });
    if (isRetail0) {
      setisRetailVisible(true);
    } else {
      setisRetailVisible(false);
    }
    setAssetUnderManagementData(tempData);
  }, [getAssetUnderManagement?.graphValues]);

  const renderColorfulLegendText = (value) => {
    switch (value) {
      case "aum":
        return (
          <span
            onClick={() => setIsAllclientsVisible(!isAllclientsVisible)}
            style={{ color: "black" }}
          >
            All Clients
          </span>
        );
      case "managedClientsAUM":
        return (
          <span
            onClick={() => setIsManagedVisible(!isManagedVisible)}
            style={{ color: "black" }}
          >
            Advisory{" "}
          </span>
        );
      case "retailClientsAUM":
        return (
          <span
            onClick={() => setisRetailVisible(!isRetailVisible)}
            style={{ color: "black" }}
          >
            Retail
          </span>
        );
    }
  };

  const CustomTooltipForPercentage = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <div className="date">{payload[0].payload.date}</div>
          {payload.map((data) => (
            <>
              {data.name === "aum" ? (
                <p className="labelPortfolio">
                  <div className="circle">&nbsp;</div>
                  <div className="value">{`$${data.value}`}</div>
                </p>
              ) : (
                <p className="label">{`${getFullIndexName(data.name)} = $${
                  data.value
                }`}</p>
              )}
            </>
          ))}
        </div>
      );
    }
    return null;
  };

  const getFullIndexName = (shortIndexName) => {
    switch (shortIndexName) {
      case "managedClientsAUM":
        return "Advisory";

      case "retailClientsAUM":
        return "Retail";
    }
  };

  const getTotal = (total, format = "float") => {
    let formattedTotal = "$0";
    if (total >= 1e6 && total < 1e9) {
      formattedTotal =
        "$" +
        parseFloat(parseInt(total) / 1e6).toFixed(format == "float" ? 2 : 0) +
        "M";
    } else if (total >= 1e9 && total < 1e12) {
      formattedTotal =
        "$" +
        parseFloat(parseInt(total) / 1e9).toFixed(format == "float" ? 2 : 0) +
        "M";
    } else if (total >= 1e3 && total < 1e6) {
      formattedTotal =
        "$" +
        parseFloat(parseInt(total) / 1e3).toFixed(format == "float" ? 2 : 0) +
        "K";
    } else if (total < 1e3) {
      formattedTotal =
        "$" + parseFloat(total).toFixed(format == "float" ? 2 : 0);
    }
    return formattedTotal;
  };

  const handleFilterClick = (option) => {
    setSelectedFilter(option === selectedFilter ? "" : option);
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(
      getAssetUnderManagementGraph(
        option === selectedFilter ? "default" : option
      )
    );
  };

  const handleFilterClickOnTopAccount = (filterButton) => {
    if (filterButton === "All") {
      setCurrentTopClients(topClients?.topClients);
      setSelecetdFilteButtonInTopClients("All");
    } else if (filterButton === "Advisory") {
      setCurrentTopClients(topClients?.topAdvisoryClients);
      setSelecetdFilteButtonInTopClients("Advisory");
    } else if (filterButton === "Retail") {
      setCurrentTopClients(topClients?.topRetailClients);
      setSelecetdFilteButtonInTopClients("Retail");
    }
  };

  const getBackGroundColor = (index) => {
    switch (index) {
      case 0:
        return "#004576";
      case 1:
        return "#0074C6";
      case 2:
        return "#008EF2";
      case 3:
        return "#46B3FF";
      case 4:
        return "#95D3FF";
      case 5:
        return "#D9EFFF";
    }
  };

  useEffect(() => {
    if (setAdvisorNote?.hasOwnProperty("noteId")) {
      dispatch(getIndividualAccountNotes(activeAccountId));
    }
  }, [setAdvisorNote]);

  useEffect(() => {
    if (advisorClientDetails?.hasOwnProperty("userId")) {
      dispatch({ type: SET_LOADING, payload: false });
      setIsLoaded(false);
      dispatch(individualAccountDetailsAction(advisorClientDetails?.userId));
    }
  }, [advisorClientDetails]);

  const handleClientNameClick = (clientId) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(advisorClientDetailsAction(clientId));
    dispatch(getIndividualAccountNotes(clientId));
    setActiveAccountId(clientId);
    setIsAdvisorIndividualClientSummaryModalShow(true);
  };

  const handleAdvisorIndividualClientSummaryModalOnClose = () => {
    setIsAdvisorIndividualClientSummaryModalShow(false);
    dispatch(resetAdvisorNote());
  };

  const handleNotePost = (text) => {
    dispatch(postAdvisorNote(activeAccountId, text));
  };

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <AdvisorIndividualClientSummaryModal
        isAdvisorIndividualClientSummaryModalShow={
          isAdvisorIndividualClientSummaryModalShow
        }
        advisorIndividualClientSummaryModalOnClose={
          handleAdvisorIndividualClientSummaryModalOnClose
        }
        data={advisorClientDetails}
        postNote={handleNotePost}
        individualAccountNotes={individualAccountNotes}
        individualAccountDetails={individualAccountDetails}
        setAdvisorNote={setAdvisorNote}
      />
      <div style={{ marginLeft: "80px" }}>
        <HeaderWithoutLogin
          isWelcomeMessageHidden={true}
          isLogoClickFromAdvisorPortal={true}
          isHelpButtonVisible={false}
        />
      </div>
      <AdvisorSideBar activeSection={1} />
      <BodyWrapper>
        <div className="topSection">
          <div className="greetingsSection">
            <div className="welcomeMessage">
              Welcome,{" "}
              <span className="userName">
                {userAccountDetails?.firstName || ""}{" "}
                {userAccountDetails?.lastName || ""}
              </span>
            </div>
          </div>
          <div className="chartsAndTables">
            <div className="section">
              <div style={{ display: "flex", width: "100%" }}>
                <div className="sectionHeading" style={{ width: "50%" }}>
                  Assets Under Management
                </div>
                <div className="heading" style={{ width: "50%" }}>
                  <div>&nbsp;</div>
                  <div>
                    <span style={{ fontSize: "15px" }}>Filter: </span>
                    <button
                      style={{
                        border:
                          selectedFilter === "ThreeMonths"
                            ? "1px solid gray"
                            : "none",
                      }}
                      className="filterButton"
                      onClick={() => handleFilterClick("ThreeMonths")}
                    >
                      3 mo.
                    </button>
                    <button
                      className="filterButton"
                      style={{
                        border:
                          selectedFilter === "YearToDate"
                            ? "1px solid gray"
                            : "none",
                      }}
                      onClick={() => handleFilterClick("YearToDate")}
                    >
                      YTD
                    </button>
                    <button
                      style={{
                        border:
                          selectedFilter === "OneYear"
                            ? "1px solid gray"
                            : "none",
                      }}
                      className="filterButton"
                      onClick={() => handleFilterClick("OneYear")}
                    >
                      1 Year
                    </button>
                  </div>
                </div>
              </div>
              <div className="benchmarkChart">
                <div className="info">
                  <div className="total">
                    {getTotal(getAssetUnderManagement?.totalAUM)}
                  </div>
                  <div className="" style={{ fontSize: "18px" }}>
                    Total as of{" "}
                    {new Date(
                      getAssetUnderManagement?.loadedDate
                    ).toLocaleDateString() || new Date().toLocaleDateString()}
                  </div>
                  <div className="categoryData">
                    <div className="eachCategoryData">
                      <div className="categoryTotal">
                        {getTotal(getAssetUnderManagement?.advisoryAUM)}
                      </div>
                      <div className="categoryName">Advisory</div>
                    </div>
                    <div className="eachCategoryData">
                      <div className="categoryTotal">
                        {getTotal(getAssetUnderManagement?.retailAUM)}
                      </div>
                      <div className="categoryName">Retail</div>
                    </div>
                  </div>
                </div>
                <div className="chart">
                  <ResponsiveContainer
                    width="100%"
                    height={window.screen.width < 480 ? 120 : 220}
                  >
                    <LineChart
                      width={500}
                      height={220}
                      data={assetUnderManagementData}
                      syncId="anyId"
                      margin={{
                        top: 10,
                        right: 0,
                        left: 0,
                        bottom: 10,
                      }}
                    >
                      <Legend
                        wrapperStyle={{ position: "static", marginTop: -10 }}
                        iconType="plainline"
                        formatter={renderColorfulLegendText}
                      />
                      <Tooltip
                        separator=" = "
                        itemStyle={{ color: "black" }}
                        content={<CustomTooltipForPercentage />}
                      />
                      <CartesianGrid vertical={false} />
                      <XAxis dataKey="date" interval="preserveEnd" />
                      <YAxis
                        axisLine={false}
                        tickLine={false}
                        //unit="%"
                        //label={<CustomizedLabel />}
                        tickFormatter={(value) => getTotal(value, "integer")}
                        padding={{ bottom: 20 }}
                        //domain={[minPercentage, maxPercentage]}
                      />
                      <Tooltip
                        separator=" = "
                        itemStyle={{ color: "black" }}
                        //content={<CustomTooltipForPercentage />}
                      />
                      <Line
                        type=""
                        dot={false}
                        dataKey="aum"
                        stroke="#48C8F4"
                        fill="#48C8F4"
                        strokeWidth={4}
                        hide={isAllclientsVisible}
                      />
                      <Line
                        type=""
                        dot={false}
                        dataKey="managedClientsAUM"
                        stroke="#004576"
                        fill="#004576"
                        strokeWidth={2}
                        hide={isManagedVisible}
                      />
                      <Line
                        type=""
                        dot={false}
                        dataKey="retailClientsAUM"
                        stroke=" #008EF2"
                        fill=" #008EF2"
                        strokeWidth={2}
                        hide={isRetailVisible}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <div className="relationshipTopAccounts">
            <div className="relationship">
              <div className="sectionHeading">Relationships</div>
              <div className="relationshipSection">
                <div className="relationshipCard">
                  <div className="flexContainer">
                    <div className="chartContainer">
                      <div className="totalValue"></div>
                      <div style={{ width: "300px", maxWidth: "300px" }}>
                        <ReactApexChart
                          options={chartData.options}
                          series={[
                            parseInt(
                              advisorDashboardRelationships?.myClientsChart
                                ?.advisory
                            ) || 0,
                            parseInt(
                              advisorDashboardRelationships?.myClientsChart
                                ?.retail
                            ) || 0,
                          ]}
                          type="donut"
                        />
                      </div>
                      <div className="informationContainer">
                        <div
                          style={{
                            fontSize: "20px",
                            color: "#004576",
                            fontWeight: 700,
                            position: "absolute",
                            textDecoration: "underline",
                            left: "14%",
                          }}
                        >
                          My Clients
                        </div>
                        <div className="legends">
                          <div className="customLegend">
                            <div className="value" style={{ color: "#004576" }}>
                              {
                                advisorDashboardRelationships?.myClientsChart
                                  ?.advisory
                              }
                            </div>
                            <div className="name">Advisory</div>
                          </div>
                          <div className="customLegend">
                            <div className="value" style={{ color: "#008EF2" }}>
                              {
                                advisorDashboardRelationships?.myClientsChart
                                  ?.retail
                              }
                            </div>
                            <div className="name">Retail</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="arrowContainer">
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          history.push(
                            "/advisor-portal-account-management/my-clients"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="relationshipCard">
                  <div className="flexContainer">
                    <div className="chartContainer">
                      <div className="totalValue"></div>
                      <div style={{ width: "300px", maxWidth: "300px" }}>
                        <ReactApexChart
                          options={chartData.options}
                          series={[
                            parseInt(
                              advisorDashboardRelationships?.retailPipelineChart
                                ?.pendingFunds
                            ) || 0,
                            parseInt(
                              advisorDashboardRelationships?.retailPipelineChart
                                ?.inProgress
                            ) || 0,
                          ]}
                          type="donut"
                        />
                      </div>
                      <div className="informationContainer">
                        <div
                          style={{
                            fontSize: "20px",
                            color: "#004576",
                            fontWeight: 700,
                            position: "absolute",
                            textDecoration: "underline",
                            left: "11%",
                          }}
                        >
                          Retail Pipeline
                        </div>
                        <div className="legends">
                          <div className="customLegend">
                            <div className="value" style={{ color: "#004576" }}>
                              {
                                advisorDashboardRelationships
                                  ?.retailPipelineChart?.pendingFunds
                              }
                            </div>
                            <div className="name">Pending Funds</div>
                          </div>
                          <div className="customLegend">
                            <div className="value" style={{ color: "#008EF2" }}>
                              {
                                advisorDashboardRelationships
                                  ?.retailPipelineChart?.inProgress
                              }
                            </div>
                            <div className="name">In Progress</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="arrowContainer">
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          history.push(
                            "/advisor-portal-account-management/retail-pipline"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="topAccounts">
              <div className="sectionHeading">Top Accounts</div>
              <div className="topAccountsCard">
                <div className="filter">
                  <div className="filterText" style={{ color: "#004576" }}>
                    Showing:
                  </div>
                  <button
                    className={`filterButton ${
                      selecetdFilteButtonInTopClients === "All" && "active"
                    }`}
                    onClick={() => handleFilterClickOnTopAccount("All")}
                  >
                    All
                  </button>
                  <button
                    className={`filterButton ${
                      selecetdFilteButtonInTopClients === "Advisory" && "active"
                    }`}
                    onClick={() => handleFilterClickOnTopAccount("Advisory")}
                  >
                    Advisory
                  </button>
                  <button
                    className={`filterButton ${
                      selecetdFilteButtonInTopClients === "Retail" && "active"
                    }`}
                    onClick={() => handleFilterClickOnTopAccount("Retail")}
                  >
                    Retail
                  </button>
                </div>
                <div className="progressBar">
                  {currentTopClients &&
                    currentTopClients?.length >= 1 &&
                    currentTopClients?.map((data, index) => (
                      <div
                        style={{
                          borderTopLeftRadius: index === 0 && "10px",
                          borderBottomLeftRadius: index === 0 && "10px",
                          borderTopRightRadius: index === 5 && "10px",
                          borderBottomRightRadius: index === 5 && "10px",
                          width: `${parseFloat(data?.allocation) * 100}%`,
                          height: "100%",
                          backgroundColor: getBackGroundColor(index),
                        }}
                      ></div>
                    ))}
                </div>
                <div className="data">
                  <table>
                    <tr>
                      <th>Client</th>
                      <th>Market Value</th>
                      <th>Allocation</th>
                    </tr>
                    {currentTopClients &&
                      currentTopClients?.length >= 1 &&
                      currentTopClients?.map((data, index) => (
                        <tr>
                          <td
                            onClick={() =>
                              handleClientNameClick(data?.clientId)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="box"
                              style={{
                                backgroundColor: getBackGroundColor(index),
                              }}
                            ></div>
                            {data?.clientName}
                          </td>
                          <td>
                            $
                            {parseFloat(data?.marketValue)
                              ?.toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>
                          <td>
                            {parseFloat(data?.allocation * 100).toFixed(2)}%
                          </td>
                        </tr>
                      ))}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default AdvisorPortalLanding;
